function startOfDay(d: Date): Date {
  const out = new Date(d);
  out.setHours(0, 0, 0, 0);
  return out;
}

function diffInDays(a: Date, b: Date): number {
  const ms = startOfDay(a).getTime() - startOfDay(b).getTime();
  return Math.round(ms / 86_400_000);
}

function isoFromDate(d: Date): string {
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("-");
}

export function todayIso(): string {
  return isoFromDate(new Date());
}

// First day of next week (Monday). If today is Monday, returns Monday + 7.
export function nextWeekStartIso(now: Date = new Date()): string {
  const dow = now.getDay(); // 0=Sun … 6=Sat
  const daysUntilMon = ((1 - dow + 7) % 7) || 7;
  return addDaysIso(isoFromDate(now), daysUntilMon);
}

const SATURDAY = 6;

export function weekendStartIso(now: Date = new Date()): string {
  const daysUntilSaturday = (SATURDAY - now.getDay() + 7) % 7;
  return addDaysIso(isoFromDate(now), daysUntilSaturday);
}

export function nextWeekendStartIso(now: Date = new Date()): string {
  const daysUntilSaturday = ((SATURDAY - now.getDay() + 7) % 7) || 7;
  return addDaysIso(isoFromDate(now), daysUntilSaturday);
}

export function isWeekend(now: Date = new Date()): boolean {
  const dow = now.getDay();
  return dow === SATURDAY || dow === 0;
}

export function addDaysIso(iso: string, days: number): string {
  const [y, m, d] = iso.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  date.setDate(date.getDate() + days);
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
}

export type DueLabel = {
  text: string;
  tone: "overdue" | "today" | "tomorrow" | "neutral";
};

export function formatDueLabel(iso: string, now: Date = new Date()): DueLabel {
  const [y, m, d] = iso.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  const days = diffInDays(date, now);
  if (days < 0) {
    return {
      text: date.toLocaleDateString("ru-RU", { month: "short", day: "numeric" }),
      tone: "overdue",
    };
  }
  if (days === 0) return { text: "Сегодня", tone: "today" };
  if (days === 1) return { text: "Завтра", tone: "tomorrow" };
  return {
    text: date.toLocaleDateString("ru-RU", { month: "short", day: "numeric" }),
    tone: "neutral",
  };
}

export function plannedGroupLabel(key: string): string {
  switch (key) {
    case "overdue": return "Прошедшие";
    case "today": return "Сегодня";
    case "later_today": return "Позже сегодня";
    case "tomorrow": return "Завтра";
    case "next_5_days": return "Ближайшие 5 дней";
    case "later": return "Позднее";
    default: return key;
  }
}

export function formatTimestamp(iso: string, now: Date = new Date()): string {
  const date = new Date(iso);
  return date.toLocaleString("ru-RU", {
    day: "numeric",
    month: "short",
    year: date.getFullYear() === now.getFullYear() ? undefined : "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
